import axios from "axios";
import url from "../config/urlServiceConfig";

const userAPI = {
  getAll: () => axios.get(url.user),
  getCAUser: (params) => axios.get("CAUser", { params }),
  getPPlusEPMO: () => axios.get(`${url.user}/PPlusEPMO`),
  getById: (params) => axios.get("ByUser", { params }),
  create: (body) => axios.post(url.user, body),
  update: (body) => axios.put(url.user, body),
  delete: (body) => axios.delete(url.user, { data: body }),
  validateUsername: (username) => axios.post(`${url.user}/Validate`, username),
  getResources: () => axios.get(`Resources`),
  replace: (body) => axios.post(`${url.user}/Replace`, body)
};

export default userAPI;
